export default "__VITE_ASSET__PRrIhRLd__"